<ion-header>
	<ion-toolbar>
		<ion-title>Comms record</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" color="primary">
				<ion-icon slot="icon-only" name="close-sharp"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
@if (form) {
	<div class="container">
		<div class="scroll-vertical app-padding form-group" [formGroup]="form">
			<app-text-input class="validatable-control" label="Client contact" placeholder="name..." inputMode="text" formControlName="clientContactName"></app-text-input>
			<app-user-picker class="validatable-control" label="Hospital contact" [formControl]="hospitalContactUserControl"></app-user-picker>
			<app-datetime class="validatable-control" label="Occurred" placeholder="choose..." dateFormat="date-time" [displayRelative]="true" formControlName="communicationDate"></app-datetime>
			<app-select class="validatable-control" label="Method" placeholder="choose..." [items]="communicationMethodItems" [saveValue]="true" formControlName="communicationMethod"></app-select>
			<app-textarea class="validatable-control" label="Comms entry" placeholder="entry..." formControlName="communicationText"></app-textarea>
		</div>
		<div class="footer-box app-padding">
			<app-button [disabled]="!form.value.recordId" (click)="removeEntry()">Remove</app-button>
			<app-button fill="solid" (click)="saveEntry()">Save</app-button>
		</div>
	</div>
}
@else {
	<app-spinner class="margin-top"></app-spinner>
}